export default __webpack_public_path__ + "f732387f51a3ed1980f31a3221e5dd6c.gif";